import * as marietta from '../..';
import { SVGSprite } from '../flash/display';

/**
 * 屋根のitemcontrollerクラス
 */
export default class ItemControllerRoof {
  target: marietta.webcad.item.Roof;

  cornerPickerList: any[] = [];

  stretchLines: marietta.webcad.control.parts.StrechLine[] = [];

  startPoint: marietta.core.Point;

  x: number;

  y: number;

  prevPoint: marietta.core.Point;

  public spt: SVGSprite;

  public emptySpt: SVGSprite;

  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.Roof) {
    // ターゲット
    this.target = _target;
    // 作成する階
    const tarLayer: marietta.webcad.layer.FloorShitaeLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor, true) as marietta.webcad.layer.FloorShitaeLayer;
    // 形状の生成
    const viewObj: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    this.spt = new SVGSprite(viewObj);

    // コントローラー追加
    const points: number = this.target.itemInfo.dotList.length;
    let corner: marietta.webcad.control.parts.SiteCornerDragger;
    let line: marietta.webcad.control.parts.StrechLine;
    for (let i: number = 1; i <= points; i += 1) {
      corner = new marietta.webcad.control.parts.SiteCornerDragger(this.spt, i);
      corner.moveFunc = this.onMoveCornerDragger;
      corner.moveEndFunc = this.onMoveEndCornerDragger;
      this.cornerPickerList.push(corner);
      // ラインの作成
      line = new marietta.webcad.control.parts.StrechLine(this.spt, i);
      this.stretchLines.push(line);
    }

    tarLayer.spt.addChild(this.spt);
    // コントローラーの位置調整
    this.setArrowPositions();
    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveCornerDragger = () => {
    // 移動しない

  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndCornerDragger = () => {
    // 移動しない

  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();
    this.updateTransforms();
  }

  /**
   * ターゲットにシンクロする
   * ※アイテムのドラッグ時に呼び出される
   */
  syncMeToTarget() {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.updateTransforms();
  }

  /**
   * 矢印をグリッドにスナップさせる
   * */
  // getSnapPosition(point: marietta.core.Point) {
  //   const snapUnit = 1;
  //   const gridPlace: marietta.core.Point = new marietta.core.Point(0, 0);
  //   gridPlace.x = Math.round(point.x / snapUnit) * snapUnit;
  //   gridPlace.y = Math.round(point.y / snapUnit) * snapUnit;
  //   return gridPlace;
  // }

  /**
   * 屋根の大きさを変える
   * */
  setRoofToMe(force: Boolean = false) {
    if (force) this.prevPoint = null;
    // 前回と同じ位置なら、行わない
    if (this.prevPoint != null && (this.prevPoint.x === this.emptySpt.mouseX && this.prevPoint.y === this.emptySpt.mouseY)) return;
    this.prevPoint = new marietta.core.Point(this.emptySpt.mouseX, this.emptySpt.mouseY);
    // 敷地アイテムに更新
    this.target.itemInfo.dotList = this.currentCoordinates;
    this.target.reCreateImage();
    // 関連するシンボルの位置移動
    this.setArrowPositions();
  }

  /**
   * 現在の座標を取得
   * */
  get currentCoordinates(): marietta.webcad.collection.PointCollection[] {
    // 基本的な情報は引き継ぐ
    const points: number = this.cornerPickerList.length;
    const myCoordinates: marietta.webcad.collection.PointCollection[] = [];
    for (let i: number = 0; i < points; i += 1) {
      myCoordinates.push(this.target.itemInfo.dotList[i]);
    }
    let tarSymbol: marietta.webcad.control.parts.SiteCornerDragger;
    // グローバル座標
    for (let i: number = 0; i < points; i += 1) {
      tarSymbol = this.cornerPickerList[i] as marietta.webcad.control.parts.SiteCornerDragger;
      myCoordinates[i].x = tarSymbol.x;
      myCoordinates[i].y = tarSymbol.y;
    }
    return myCoordinates;
  }

  /**
   * 矢印位置を合わせる
   * */
  setArrowPositions() {
    // 頂点作成
    let cornerPicker: marietta.webcad.control.parts.RoomCornerDragger;
    let line: marietta.webcad.control.parts.StrechLine;
    let i: number;

    for (i = 0; i < this.cornerPickerList.length; i += 1) {
      cornerPicker = this.cornerPickerList[i];
      cornerPicker.move(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
    }
    for (i = 0; i < this.stretchLines.length; i += 1) {
      line = this.stretchLines[i];
      line.firstDot = new marietta.core.Point(this.target.itemInfo.dotList[i].x, this.target.itemInfo.dotList[i].y);
      if (i === this.stretchLines.length - 1) {
        line.secondDot = new marietta.core.Point(this.target.itemInfo.dotList[0].x, this.target.itemInfo.dotList[0].y);
      } else {
        line.secondDot = new marietta.core.Point(this.target.itemInfo.dotList[i + 1].x, this.target.itemInfo.dotList[i + 1].y);
      }
    }
    // お掃除
    cornerPicker = null;
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.update();
  }

  /**
   * ピッカーのサイズ更新
   */
  public updatePickers(): void {
    for (let i: number = 0; i < this.cornerPickerList.length; i += 1) {
      (this.cornerPickerList[i] as marietta.webcad.control.parts.SiteCornerDragger).updateTranslate();
    }
  }
}
